import * as React from 'react';
export var IconCheckCircleFill = React.forwardRef(function IconCheckCircleFill({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm2.71 6.345a.75.75 0 0 0-.915-1.19l-2.68 2.062-.79-.944a.75.75 0 0 0-1.15.963l1.252 1.496a.75.75 0 0 0 1.033.113l3.25-2.5Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm3.765 7.292a.75.75 0 1 0-1.038-1.083l-4.073 3.902-1.295-1.8a.75.75 0 1 0-1.218.877l1.8 2.5a.75.75 0 0 0 1.128.103l4.696-4.499Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm3.765 7.292a.75.75 0 1 0-1.038-1.083l-4.073 3.902-1.295-1.8a.75.75 0 1 0-1.218.877l1.8 2.5a.75.75 0 0 0 1.128.103l4.696-4.499Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
